module.exports = __webpack_public_path__ + "static/media/using-sales-navigator-5.2740809c.gif";